<mat-horizontal-stepper #stepper [linear]="true" class="w-100 h-100 text-start">
  <mat-step label="Nuevo Setup">
    <div class="row w-75 mx-auto justify-content-center gy-2">
      <img class="col-12 w-50 mx-auto" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/undraw/undraw-notify.svg" alt="Notificación imagen">
      <h2 class="col-8 text-center">Estas a punto de crear una nueva etapa <strong>¿Deseas continuar?</strong></h2>
      <div class="w-100 d-flex align-items-center justify-content-center m-2">
        <mat-radio-group [(ngModel)]="newPrescriptionOption">
          <mat-radio-button [value]="1" [ngClass]="{'prescription-option-container mx-2': newPrescriptionOption === 1}">Crear nueva prescripción</mat-radio-button>
          <mat-radio-button [value]="2" [ngClass]="{'prescription-option-container mx-2': newPrescriptionOption === 2}">Utilizar misma prescripción de etapa anterior</mat-radio-button>
        </mat-radio-group>
      </div>
      <button mat-button class="button primary-button col-6" (click)="createNewBlankSetup()">Continuar <mat-icon>check</mat-icon></button>
    </div>
  </mat-step>
  <!-- CASE FILE -->
  <mat-step label="Registros dentales"  *ngIf="newPrescriptionOptionSelected != null && newPrescriptionOptionSelected">
    <app-client-crud-casefile></app-client-crud-casefile>
    <div class="row w-50 gx-4 justify-content-center mx-auto">
      <button mat-button matStepperNext class="button secondary-button col-6 m-0" (click)="updateSetupCurrentStepPrescription()" *ngIf="newPrescriptionOption == 1">Prescripción<mat-icon>chevron_right</mat-icon></button>
    </div>
  </mat-step>
  <!-- PRESCRIPTION -->
  <mat-step label="Prescripción"  *ngIf="newPrescriptionOption == 1 && newPrescriptionOptionSelected">
    <app-client-crud-prescription></app-client-crud-prescription>
    <div class="row w-50 gx-4 justify-content-center mx-auto">
      <button mat-button matStepperPrevious class="button secondary-button col-6 m-0"><mat-icon>chevron_left</mat-icon> Registros dentales </button>
    </div>
  </mat-step>
</mat-horizontal-stepper>
